document.addEventListener('DOMContentLoaded', () => {
  // --- Funkcje Ciasteczek ---
  function setCookie(name, value, days) {
      let expires = "";
      if (days) {
          const date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
  }
  
  // --- Logika Pop-upu ---
  const popupOverlay = document.getElementById('specialOfferPopup');
  if (!popupOverlay) return;

  function showPopup() {
      popupOverlay.style.display = 'flex';
  }

  function closePopup() {
    popupOverlay.style.animation = 'fadeOut 0.3s ease-out';
    setTimeout(() => {
        popupOverlay.style.display = 'none';
    }, 280);
    setCookie('newsletterPopupShown', 'true', 30); // Ustaw ciasteczko na 30 dni
  }

  // ZAKTUALIZOWANA LOGIKA WYŚWIETLANIA
  // Pokaż pop-up tylko jeśli ciasteczko nie istnieje ORAZ jesteśmy na stronie głównej
  if (!getCookie('newsletterPopupShown') && typeof onHomePage !== 'undefined' && onHomePage) {
      setTimeout(showPopup, 1500); // Pokaż po 1.5s
  }

  // --- Event Listeners ---
  const closeButton = popupOverlay.querySelector('.close-button');
  if (closeButton) {
    closeButton.addEventListener('click', closePopup);
  }

  popupOverlay.addEventListener('click', function(event) {
      if (event.target === this) {
          closePopup();
      }
  });

  document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && popupOverlay.style.display === 'flex') {
          closePopup();
      }
  });
  
  const newsletterForm = popupOverlay.querySelector('.newsletter-form');
  if(newsletterForm) {
      newsletterForm.addEventListener('submit', function(e) {
          // Tutaj w przyszłości możesz dodać logikę wysyłania formularza
          // Na razie po prostu zamyka okienko
          closePopup();
      });
  }
});